<div class="fill-height">
  <div>
    <div fa-pane="fa-pane" pane-id="control-top-tabs" pane-anchor="">
      <div class="widget-container fluid-height">
        <div class="card-body" style="padding: 0; margin-top: -0.4em; font-size: 13px; padding-left: 0px; padding-right: 0px;">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a id="tabs" class="nav-link active" data-bs-toggle="tab" data-bs-target="#profile">
                <i class="fa fa-user color-green" style="color: #42cd00;"></i>&nbsp;{{"Profile" | translate}}</a>
            </li>
            <li class="nav-item">
              <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#grouplist">
                <i class="fa fa-group color-skyblue" style="color: #56b7f1;"></i>&nbsp;{{"Group-List" | translate}}</a>
            </li>
            <li class="nav-item">
              <a id="tabs" class="nav-link" data-bs-toggle="tab" data-bs-target="#recentActivities">
                <i class="fa fa-history color-red" style="color: #ff2d55;"></i>&nbsp;{{"Recent Activities" | translate}}</a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div id="profile" class="tab-pane fade show active">
            <app-profile></app-profile>
          </div>
          <div id="grouplist" class="tab-pane fade">
            <app-groups></app-groups>
          </div>
          <div id="recentActivities" class="tab-pane fade">
            <app-recent-activities></app-recent-activities>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>